import axios from "axios";
import { CepDetails } from "../../@types/Cep";

export async function findOneCepDetails(
  cep: string
): Promise<CepDetails | null> {
  try {
    const { status, data } = await axios.get(
      `https://viacep.com.br/ws/${cep}/json/`
    );

    if (status === 200) {
      return data as CepDetails;
    }

    return null;
  } catch (err) {
    console.log(err);

    return null;
  }
}
